import React from "react";
import { Dropdown, Header } from "semantic-ui-react";
import { useCustomerAutoFillFinder } from "../hooks/auto-fill-finder";
import { buildTabcId } from "utilities/dist/customer/helpers";

const CustomerContainerAutoFillFinder = () => {
    const { error, query, isLoading, customers, handleChange, handleSearchChange } =
        useCustomerAutoFillFinder();

    const options = customers.map(cust => {
        const permit = cust.permitCodes[0];
        const tabcId = buildTabcId({ tabc_id: permit.permit_code, ...permit });
        return {
            key: cust.establishment_id,
            value: cust.establishment_id,
            // This is needed to ensure that on the client side, search respects any match
            text: [cust.name, cust.address, tabcId].join(", "),
            content: (
                <div className="clear">
                    <Header as="h4" floated="left">
                        {cust.name}
                        <Header.Subheader>
                            {[cust.address, cust.county, cust.city, cust.state]
                                .filter(Boolean)
                                .join(", ")}
                        </Header.Subheader>
                        <Header.Subheader>TABC ID #{tabcId}</Header.Subheader>
                    </Header>
                </div>
            ),
        };
    });

    return (
        <>
            <Header as="h5">Find your customer</Header>
            <Dropdown
                fluid
                selection
                clearable
                error={!!error}
                minCharacters={3}
                // We are already doing search on the server, whatever results are returned, show all
                search={options => options}
                autoComplete="off"
                options={options}
                loading={isLoading}
                onChange={handleChange}
                onSearchChange={handleSearchChange}
                placeholder={`Address/Establishment Name etc.`}
                icon={query.length > 2 ? "dropdown" : null}
                noResultsMessage={
                    query.length > 2 ? `Sorry, no results found for "${query}"` : null
                }
            />
        </>
    );
};

export default CustomerContainerAutoFillFinder;
